import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { IconButton, ListItem, ListItemText } from '@mui/material';
import { memo, ReactNode } from 'react';

interface RightPanelListItemProps {
  primary: string;
  secondary: string | ReactNode;
  accessState: 'all' | 'partial' | 'none';
  onAdd: () => void;
  onRemove: () => void;
  addTitle: string;
  removeTitle: string;
}

function AddRemoveListItemImpl({
  primary,
  secondary,
  accessState,
  onAdd,
  onRemove,
  addTitle,
  removeTitle,
}: RightPanelListItemProps) {
  return (
    <ListItem
      divider
      secondaryAction={
        accessState === 'all' ? (
          <IconButton edge='end' color='error' onClick={onRemove} title={removeTitle}>
            <RemoveIcon />
          </IconButton>
        ) : (
          <IconButton edge='end' color='primary' onClick={onAdd} title={addTitle}>
            <AddIcon />
          </IconButton>
        )
      }
      sx={{ height: '3rem' }}
    >
      <ListItemText primary={primary} />
      <ListItemText primary={secondary} sx={{ marginRight: '.25rem', textAlign: 'right' }} />
    </ListItem>
  );
}

export const AddRemoveListItem = memo(AddRemoveListItemImpl) as typeof AddRemoveListItemImpl;
